import FichasDePartidosList from './views/FichasDePartidosListView.vue'
import FichaDePartidoDetailView from './views/FichaDePartidoDetailView.vue'
import Selectores from './components/Selectores.vue'

export default [
  {
    path: '/fichas-partidos',
    name: 'fichasDePartidos',
    props: true,
    component: Selectores,
    children: [
      {
        path: ':torneoId/:fechaId',
        name: 'fichaDePartidoFiltered',
        props: true,
        component: FichasDePartidosList
      }
    ]
  },
  {
    path: '/fichas-partidos/:partidoId',
    name: 'fichaDePartidoDetail',
    props: true,
    component: FichaDePartidoDetailView
  }
]
